/** Only the sign-in gate's human-activity reporter emits this; output and polling never do. */
export function bindSessionActivity(socket: WebSocket, ready: () => boolean): () => void {
  const activity = () => {
    if (ready() && socket.readyState === WebSocket.OPEN)
      socket.send(JSON.stringify({ type: 'activity' }));
  };
  if (typeof window !== 'undefined') window.addEventListener('atum-remote-activity', activity);
  return () => {
    if (typeof window !== 'undefined') window.removeEventListener('atum-remote-activity', activity);
  };
}
